import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        success: 'border-transparent bg-success text-success-foreground shadow hover:bg-success/80',
        warning: 'border-transparent bg-warning text-warning-foreground shadow hover:bg-warning/80',
        info: 'border-transparent bg-info text-info-foreground shadow hover:bg-info/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

/** Map CRM status / pill semantics → Badge variants. */
function statusBadgeVariant(status) {
  const s = String(status || '').toLowerCase().replace(/\s+/g, '-');
  if (['won', 'paid', 'approved', 'completed', 'on', 'granted', 'success'].includes(s)) return 'success';
  if (['lost', 'cancelled', 'canceled', 'disputed', 'restricted', 'behind', 'destructive'].includes(s)) return 'destructive';
  if (['overdue', 'pending', 'paused', 'warning', 'stale', 'ineligible'].includes(s)) return 'warning';
  if (['open', 'planned', 'issued', 'invoiced', 'on-track', 'active', 'info', 'scope'].includes(s)) return 'info';
  return 'secondary';
}

export { Badge, badgeVariants, statusBadgeVariant };
